import { Component, OnInit } from "@angular/core";
import { ViewController, NavParams, NavController, ModalController, PopoverController, ToastController } from "ionic-angular";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { UserProvider, User } from "../../../../providers/user/user";
import { AvatarProvider } from "../../../../providers/avatar/avatar";
import { ClubProvider } from "../../../../providers/club/club";
import { FeedClub } from "../../feed-club/feed-club.component";

@Component({
    selector: 'feed-focus',
    templateUrl: 'feed-focus.component.html'
})
export class FeedFocusComponent {


    postId: string;
    isClubFeed: string;
    clubId: string;
    viewTitle: string = null;
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public popoverCtrl: PopoverController,
        public viewCtrl: ViewController,
        public modalCtrl: ModalController,
        private clubProvider : ClubProvider,
        public toastCtrl: ToastController
    ) {
        this.postId = this.navParams.get('postId');
        this.isClubFeed = this.navParams.get('isClubFeed');
        if(this.isClubFeed){
            this.clubId = this.navParams.get('clubId');
        }
    }

    ngOnInit(): void {
        if(this.isClubFeed){
            this.getClub(this.clubId)
        }
    }

    getClub(clubId){
        this.clubProvider.get(clubId).subscribe((res) => {
            if(res.success){
                this.viewTitle = res.data.name
            }
        })
    }

    joinClub(){
        this.clubProvider.join(this.clubId).subscribe((res) => {
            if(res.success){
                this.viewCtrl.dismiss();
                let modal = this.modalCtrl.create(FeedClub, {clubId: this.clubId, clubName: this.viewTitle});
                modal.present().then(() => {});
                let toast = this.toastCtrl.create({
                    message: 'Vous avez rejoint le club '+this.viewTitle,
                    duration: 3000,
                    position: 'top'
                  });
                  toast.present();
            }else{
                let toast = this.toastCtrl.create({
                    message: 'Vous êtes déjà membre du groupe '+this.viewTitle,
                    duration: 3000,
                    position: 'top'
                  });
                  toast.present();
            }
        })
    }

    dismiss(): void {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/employee/profile/feed-focus/feed-focus.component.ts